import {Platform} from 'react-native';

import RNFS from './RNFS';
import DataController from './DataController';
import {PSIRF_TYPES} from '../constants/psirf';

export default {
  getImagePath(filename: string, recordID: string): string {
    if (!recordID) return filename;
    if (!filename) return '';

    const key = `${recordID}/${filename}`;
    if (Platform.OS === 'web') {
      return `https://ppp-temp-files.s3.amazonaws.com/PSIRF/${key}`;
    }
    const fullFilePath = `${RNFS.DocumentDirectoryPath}/PSIRF/${key}`;

    if (Platform.OS === 'android') {
      return `file://${fullFilePath}`;
    }

    return fullFilePath;
  },

  async downloadImageHandler(
    filename: string,
    fileSize: number,
    recordID: string,
    url: string,
  ) {
    console.log(filename, fileSize, recordID, url);
    const fullFileName = `PSIRF/${recordID}/${filename}`;
    const updatedUrl = url.replace(/ /g, '%20');

    const didDownload = await DataController.downloadImage(
      fullFileName,
      updatedUrl,
      fileSize,
    );
    console.log('didDownload', didDownload, fullFileName);
  },

  async downloadPsirfImage(psirf: Object) {
    if (!psirf?.content?.length || Platform.OS === 'web') {
      return psirf;
    }

    const updatedContent = await Promise.all(
      psirf.content.map(async item => {
        const {type, content} = item;

        if (type === PSIRF_TYPES.TOP_SECTION) {
          const image = content.TopImage[0];
          const filePath = await DataController.downloadImageHandler(
            image.filename,
            image.url,
            image.size,
            'psirf',
          );
          return {
            ...item,
            content: {
              ...content,
              TopImage: [{...image, url: filePath}],
            },
          };
        }

        if (type === PSIRF_TYPES.EXTENDED_LEARNING) {
          content.Images.map(async image => {
            await this.downloadImageHandler(
              image.filename,
              image.size,
              content.ID,
              image.url,
            );
          });
        }

        return item;
      }),
    );

    return {...psirf, content: updatedContent};
  },
};
